var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import cls from "classnames";
import React from "react";
import { ImageUpload } from "../../image-upload";
import { TextField } from "../../text-field";
import { PollOptionBase } from "../PollOptionBase";
import styles from "./option-webview-scss";
class PollGridOptionWebview extends PollOptionBase {
  render() {
    const { option, dark, t } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.option, styles.grid, {
          [styles.with_image]: this.isImageEnabled(),
          [styles.dark]: dark
        })
      },
      this.isImageEnabled() && /* @__PURE__ */ React.createElement(ImageUpload, { className: styles.image, value: option.image.src.url }),
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          className: cls(styles.input),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder")
        }
      ))
    );
  }
}
__publicField(PollGridOptionWebview, "propTypes", PollOptionBase.propTypes);
export {
  PollGridOptionWebview
};
//# sourceMappingURL=PollGridOptionWebview.js.map
